import { render, staticRenderFns } from "./ResponseBox.vue?vue&type=template&id=dbc475b4&scoped=true"
import script from "./ResponseBox.vue?vue&type=script&lang=js"
export * from "./ResponseBox.vue?vue&type=script&lang=js"
import style0 from "./ResponseBox.vue?vue&type=style&index=0&id=dbc475b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc475b4",
  null
  
)

export default component.exports